import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import analytics from 'js/services/Analytics';

import Button from 'js/components/common/Button';
import {googleColor, greenButtonColor, lightGrey1Color} from 'js/config/style';
import { action } from 'mobx';

const passPredicate = () => true;
const noop = () => null;

@observer
export default class GoogleConnectButton extends Component {
  @observable
  isConnecting = false;
  @action
  setIsConnecting(isConnecting) {
    this.isConnecting = isConnecting;
  }

  // onConnect = response => {
  //   let tracking;
  //   if(!response){
  //     return;
  //   }
  //   if (response.is_new_user) {
  //     tracking = analytics.track(
  //       AppState.currentPage === 'BuyerSignupPage' ? 'BAA_account created' : 'AA_account created',
  //       {
  //         user_id: response.id,
  //         email: response.email,
  //         sign_up_method: 'google',
  //       },
  //     );
  //   } else {
  //     tracking = analytics.track('AA_logged in', {
  //       user_id: response.id,
  //       email: response.email,
  //       login_method: 'google',
  //     });
  //   }
  //   return tracking.then(this.props.onConnect);
  // };
  //
  // loginNow = () => {
  //   console.log('loginNow');
  //   this.setIsConnecting(true);
  //   AppUser.loginUser(this.props.scope || 'email', this.props.addParams, 'google')
  //     .then(this.onConnect)
  //     .catch(error => {
  //
  //       (this.props.onError || noop)(
  //         error.response ? error.response.data.message : (error === 'popup_blocked_by_browser' ? error : 'Could not connect with Google')
  //       );
  //       this.setIsConnecting(false);
  //     });
  // };
  //
  // triggerLogin = () => Promise.all([(this.props.beforeConnect || noop)(), this.props.prnt()]).then(() => this.loginNow());

  onClick = () => {
    this.setIsConnecting(true);
    const mseller = AppState.currentPage === 'MSellerPage';
    const checkout = AppState.currentPage === 'CheckoutPage';

    analytics
      .track(mseller ? 'CTA_SP_mseller_signup_google' : checkout ? 'CTA_BP_checkout_signup_google' : 'Sign Up Button Clicked', {
        'Email': '',
        'Signup Method': 'Google',
        'Name': this.props.page ? this.props.page.full_name : '',
        'Address': this.props.page ? this.props.page.address : '',
        'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
        'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
          ? 'seller' : 'buyer'
      });

    this.props.callParentClick();
  }

  render() {
    let {
      children,
      icon,
      color,
      predicate,
      isLoading,
      gotoSellItem,
      fullWidth,
      onConnect,
      addParams,
      beforeConnect,
      mseller,
      ...rest
    } = this.props;

    isLoading = isLoading || this.isConnecting;
    // if (AppState.currentPage === 'SPPOnboardLogin'){
    //   color = greenButtonColor;
    // }
    return (

      <Button
        color={color || googleColor.hex()}
        icon={typeof icon !== 'undefined' ? icon : 'google'}
        isLoading={isLoading}
        onClick={this.onClick}
        style={{'marginTop': '5px'}}>
        {isLoading ? 'Connecting With Google' : children || 'Continue with Google'}
      </Button>
    );
  }
}
